import { createSlice } from '@reduxjs/toolkit';
import { getJobDefinition } from 'ducks/job-definition/operators';
import { Slices } from 'ducks/slices';
import { JobDefinitionItem } from 'ducks/types/store-types';
import { NullableNumberInterface } from 'ducks/types/type-helpers';
import { normalizeJobDefinition } from 'ducks/utils';

export type JobDefinitionState = NullableNumberInterface<JobDefinitionItem>;

const initialState: JobDefinitionState = {
  job_definition_id: null,
  job_definition_name: '',
  project_id: null,
  project_name: '',
  organization_id: null,
  organization_name: '',
  docker_image: '',
  startup_command: '',
  cpu: 1,
  gpu: 0,
  memory_gb: 1,
  shared_memory_mb: 64,
  storage_gb: 1,
  billing_identifier: '',
  timeout_seconds: 86400,
  timeout_seconds_masked: '24:00:00',
  prevent_preemption_name: 'No',
  prevent_preemption: false,
  description: '',
  created_by: '',
  created_datetime_utc: '',
  result_method_id: 1,
  result_method_name: '',
  stdout_success_text: '',
  max_retries: 0,
  location_group_id: null,
  location_group_name: '',
  is_archived: false,
  modified: false,
  cpu_architecture_id: null,
  cpu_architecture_name: '',
  sort_datetime_utc: '',
  created_datetime_utc_formatted: '',
  sort_datetime: '',
  local_timezone: '',
  created_datetime_formatted: '',
  uuid: '',
};

const jobDefinitionSlice = createSlice({
  name: Slices.JOB_DEFINITION,
  initialState,
  reducers: {
    setJobDefinition: (_, { payload }) => {
      return normalizeJobDefinition(payload);
    },
    updateJobDefinition: (state, { payload }) => {
      return { ...state, ...payload };
    },
    clearJobDefinition: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getJobDefinition.pending, () => {
        return initialState;
      })
      .addCase(getJobDefinition.fulfilled, (_, { payload }) => {
        return normalizeJobDefinition(payload);
      })
      .addCase(getJobDefinition.rejected, () => {
        return initialState;
      });
  },
});

export const { setJobDefinition, updateJobDefinition, clearJobDefinition } = jobDefinitionSlice.actions;

export default jobDefinitionSlice.reducer;
